import ContentMethodRichText from "../richtext/ContentMethodRichText"
import ContentMethodFileType from "./ContentMethodFileType"

const ContentMethodSubmit = ({ filetypeProps, richtextProps }) => (
  <div className="ContentMethod__Submit">
    <ContentMethodFileType {...Object.assign({}, filetypeProps)} />
    <ContentMethodRichText {...Object.assign({}, richtextProps)} />
  </div>
)

ContentMethodSubmit.displayName = "ContentMethodSubmit"
export default ContentMethodSubmit
